/**
 * CargaPesquisaSatisfacaoCollection
 *
 * @author Simpli CLI generator
 */
import {PageCollection, HttpExclude, Request} from 'simpli-web-sdk'
import {CargaPesquisaSatisfacao} from '@/model/resource/CargaPesquisaSatisfacao'

/* TODO: review generated class */
@HttpExclude()
export class CargaPesquisaSatisfacaoCollection extends PageCollection<
  CargaPesquisaSatisfacao
> {
  constructor() {
    super(CargaPesquisaSatisfacao)
  }

  queryAsPage() {
    return this.listCargaPesquisaSatisfacao()
  }

  async listCargaPesquisaSatisfacao() {
    return await Request.get(`/admin/carga-pesquisa-satisfacao`, {
      params: this.params,
    })
      .name('listCargaPesquisaSatisfacao')
      .as(this)
      .getResponse()
  }

  async listCsvCargaPesquisaSatisfacao() {
    return await Request.get(`/admin/carga-pesquisa-satisfacao/csv`, {
      params: this.params,
    })
      .name('listCsvCargaPesquisaSatisfacao')
      .as(this)
      .getResponse()
  }
}
